export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    // NOTICE: KAPTION-INTEGRATION - Support prefixed favicon paths (e.g., /kaption/)
    const href = favicon.getAttribute('href') || '';
    const prefix =
      href && href.lastIndexOf('/') !== -1
        ? href.slice(0, href.lastIndexOf('/') + 1)
        : '/';
    const newFileName = `${prefix}favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        // NOTICE: KAPTION-INTEGRATION - Support prefixed favicon paths (e.g., /kaption/)
        const href = favicon.getAttribute('href') || '';
        const prefix =
          href && href.lastIndexOf('/') !== -1
            ? href.slice(0, href.lastIndexOf('/') + 1)
            : '/';
        const oldFileName = `${prefix}favicon-${favicon.sizes[[0]]}.png`;
        favicon.href = oldFileName;
      });
    }
  });
};
